import styles from './use-position-table-actions.module.scss';

import ControlPointIcon from '@mui/icons-material/ControlPoint';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as TextRow } from '@work4all/assets/icons/text-row.svg';
import { ReactComponent as TitleRow } from '@work4all/assets/icons/title-row.svg';

import {
  CustomToolbarAction,
  CustomToolbarMappedAction,
} from '@work4all/components/lib/dataDisplay/actions-bar/ToolbarTypes';

import { Article } from '@work4all/models/lib/Classes/Article.entity';
import { AddServiceContractPosTypeOfPos } from '@work4all/models/lib/Enums/AddServiceContractPosTypeOfPos.enum';

import { IEditTable } from '../edit-table/types';

export interface UsePositionTableActionsOptions {
  onAddSpecial: (
    positionType: AddServiceContractPosTypeOfPos,
    article?: Article
  ) => void;
  disabled: boolean;
  editTableRef?: React.RefObject<IEditTable>;
}

export const usePositionTableActions = (
  options: UsePositionTableActionsOptions
): CustomToolbarMappedAction[] => {
  const { onAddSpecial, disabled } = options;

  const { t } = useTranslation();
  return useMemo(() => {
    const actions: CustomToolbarAction[] = [
      {
        actionKey: AddServiceContractPosTypeOfPos.DEFAULT,
        IconComponent: ControlPointIcon,
        title: t('MASK.COMPONENT'),
        disabled,
        handler: () => {
          onAddSpecial(AddServiceContractPosTypeOfPos.TEXTLINE, { id: 0 });
        },
        mode: 'Add',
      },
      {
        actionKey: AddServiceContractPosTypeOfPos.HEADLINE,
        IconComponent: () => <TitleRow className={styles.icon} />,
        title: t('COMMON.SERVICE_CONTRACT.TITLE'),
        disabled,
        handler: () => {
          onAddSpecial(AddServiceContractPosTypeOfPos.HEADLINE);
        },
        mode: 'Add',
      },
      {
        actionKey: AddServiceContractPosTypeOfPos.TEXTLINE,
        IconComponent: () => <TextRow className={styles.icon} />,
        title: t('COMMON.SERVICE_CONTRACT.EMPTY_TEXT'),
        disabled,
        handler: () => {
          onAddSpecial(AddServiceContractPosTypeOfPos.TEXTLINE);
        },
        mode: 'Add',
      },
    ];

    const mappedActions: CustomToolbarMappedAction[] = actions.map((x) => ({
      ...x,
      onClick: () => x.handler(''),
    }));

    return mappedActions;
  }, [t, disabled, onAddSpecial]);
};
